import { apiFetch } from 'services/apiClient';

const API_BASE = (process.env.REACT_APP_API_BASE_URL || 'http://localhost:8082/api/v1').replace(/\/+$/, '');

export type FieldInspectionControlTaskResponse = {
  reportFormat?: {
    id?: number;
    publicUuid?: string;
    bulkReportTableTitle?: string | null;
    attribute?: any;
    [key: string]: any;
  };
  nodes?: Array<{
    id?: number;
    title?: string;
    sortOrder?: number;
    parentId?: number | null;
    type?: string;
    showInReportForm?: boolean;
    showInReport?: boolean;
  }>;
  itemsByNode?: Record<string, Array<{ question: any; answers: any[] }>>;
};

export const fetchFieldInspectionControlTask = (attributeId: number): Promise<FieldInspectionControlTaskResponse> =>
  apiFetch(`/field-inspections/control-task?attributeId=${attributeId}`);

export const fetchFieldInspectionControlTaskByReportFormat = (
  reportFormatIdOrUuid: number | string,
  includeInspectorExcluded = false,
): Promise<FieldInspectionControlTaskResponse> => {
  const reportFormatToken = String(reportFormatIdOrUuid ?? '').trim();
  const params = new URLSearchParams({
    includeInspectorExcluded: String(includeInspectorExcluded),
  });
  params.set(/^\d+$/.test(reportFormatToken) ? 'reportFormatId' : 'reportFormatUuid', reportFormatToken);

  return apiFetch(`/field-inspections/control-task?${params.toString()}`);
};

export const previewFieldInspectionReportPdf = async (
  reportFormatUuid: string,
  payload: {
    answers?: Record<string, any>;
    notes?: Record<string, string>;
    selectedControlAreaId?: string | number | null;
    customControlAreaName?: string | null;
  },
): Promise<{ blob: Blob; url: string }> => {
  const token = localStorage.getItem('accessToken');
  if (!token) {
    throw new Error('Missing access token');
  }

  const params = new URLSearchParams({ reportFormatUuid });
  const response = await fetch(`${API_BASE}/field-inspections/control-task/report-preview.pdf?${params.toString()}`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: 'application/pdf',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    const errorText = await response.text();
    let message = `Failed to preview report PDF: ${response.status}`;
    if (errorText) {
      try {
        const parsed = JSON.parse(errorText);
        const serverMessage = typeof parsed?.message === 'string' ? parsed.message : errorText;
        message = `${message} - ${serverMessage}`;
      } catch {
        message = `${message} - ${errorText}`;
      }
    }
    throw new Error(message);
  }

  const blob = await response.blob();
  const url = URL.createObjectURL(blob);
  return { blob, url };
};
